import { FormSectionHandler } from '../entity.handler';
import { ClientResponse, ClientUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils, ComboField } from '../utils';

interface EditorValues {
    distanceUnit?: string;
    altitudeUnit?: string;
    speedUnit?: string;
    areaUnit?: string;
    volumeUnit?: string;
    weightUnit?: string;
    timeUnit?: string;
    dateUnit?: string;
    temperatureUnit?: string;
}

export class ClientMeasurementSectionHandler implements FormSectionHandler<ClientResponse, EditorValues> {

    type = 'form';
    icon = 'weight';
    bulk = true;
    readonly = false; 


    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }


    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.CLIENT.MEASUREMENT.${key}`, values);
    }

    applyUpdate(entity: ClientResponse, payload: ClientUpdateRequest): Promise<ClientResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateClientDetails(entity.id, payload)).then(client => {
            this.admin.clientUpdated(client);
            return client;
        });
    }

    mapEntityToEditor(entity: ClientResponse): Promise<EditorValues> {
        return Promise.resolve(entity.measurementUnits || {});
    }

    mapEditorToEntity(entity: ClientUpdateRequest, values: EditorValues): Promise<any> {
        entity.measurementUnits = values as any;
        return Promise.resolve(entity);
    }

    getFields(entity: ClientResponse): Promise<FormBuilderField[]> {
        return Promise.all([
            this.admin.getCached(`getLookups/measurementUnits`, api => api.entities.getLookups('measurementUnits')),
        ]).then(([lookups]) => {
            const MeasurementComboField = (field: string) => {
                return ComboField(field, this.translate('FIELDS.' + field.replace('Unit', '').toUpperCase()), true, (lookups[field] || []).map(x => ({ key: x, value: this.translate('VALUES.' + x.toUpperCase()) })));
            };
            return [
                MeasurementComboField('dateUnit'),
                MeasurementComboField('timeUnit'),
                MeasurementComboField('distanceUnit'),
                MeasurementComboField('altitudeUnit'),
                MeasurementComboField('speedUnit'),
                MeasurementComboField('volumeUnit'),
                MeasurementComboField('weightUnit'),
                MeasurementComboField('areaUnit'),
                MeasurementComboField('temperatureUnit'),
            ];

        }).then(fields => EntityUtils.prepareBulk(!entity, fields.map(x => x.id), fields));
    }

}
